export default __webpack_public_path__ + "static/media/91702e09a26fa4d9f33593d333cf12fa1581616911149.3c8ff8fd.webp";